import AdminLayout from '../components/AdminLayout';

interface StubPageProps {
  title: string;
  subtitle: string;
  icon: string;
  description: string;
}

export default function StubPage({ title, subtitle, icon, description }: StubPageProps) {
  return (
    <AdminLayout title={title} subtitle={subtitle}>
      <div className="flex flex-col items-center justify-center py-24 text-center">
        <div className="w-20 h-20 flex items-center justify-center rounded-2xl bg-rose-50 border-2 border-rose-100 mb-5">
          <i className={`${icon} text-4xl text-rose-300`}></i>
        </div>
        <h2 className="text-lg font-bold text-gray-700 mb-2">{title}</h2>
        <p className="text-sm text-gray-400 max-w-xs">{description}</p>
        <div className="mt-6 px-5 py-2.5 rounded-xl bg-rose-50 border-2 border-rose-100 text-rose-400 text-sm font-semibold">
          בקרוב...
        </div>
      </div>
    </AdminLayout>
  );
}
